module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00475.91a8e4b5.jpg";